import {DAY, DAY_LABEL} from "../../../types/BlackoutPeriod";

export const daysOptions = [{
    label: DAY_LABEL.MONDAY,
    value: DAY.MONDAY
}, {
    label: DAY_LABEL.TUESDAY,
    value: DAY.TUESDAY
}, {
    label: DAY_LABEL.WEDNESDAY,
    value: DAY.WEDNESDAY
}, {
    label: DAY_LABEL.THURSDAY,
    value: DAY.THURSDAY
}, {
    label: DAY_LABEL.FRIDAY,
    value: DAY.FRIDAY
}, {
    label: DAY_LABEL.SATURDAY,
    value: DAY.SATURDAY
}, {
    label: DAY_LABEL.SUNDAY,
    value: DAY.SUNDAY
}];